import { get } from 'lodash';

const root = (state) => get(state, 'PowerSchoolExportState');

export const getConfigurationLoading = (state) =>
  get(root(state), 'getConfiguration.loading');
export const getConfigurationResult = (state) =>
  get(root(state), 'getConfiguration.data');
export const getConfigurationErrors = (state) =>
  get(root(state), 'getConfiguration.errors');

export const postSaveConfigurationLoading = (state) =>
  get(root(state), 'postSaveConfiguration.loading');
export const postSaveConfigurationResult = (state) =>
  get(root(state), 'postSaveConfiguration.data');
export const postSaveConfigurationErrors = (state) =>
  get(root(state), 'postSaveConfiguration.errors');

export const postTestConnectionLoading = (state) =>
  get(root(state), 'postTestConnection.loading');
export const postTestConnectionResult = (state) =>
  get(root(state), 'postTestConnection.data');
export const postTestConnectionErrors = (state) =>
  get(root(state), 'postTestConnection.errors');

export const postExportLoading = (state) =>
  get(root(state), 'postExport.loading');
export const postExportResult = (state) => get(root(state), 'postExport.data');
export const postExportErrors = (state) =>
  get(root(state), 'postExport.errors');



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/powerschoolexport/state/selectors.js